<template>
  <div
    class="auth-container"
    :style="{ backgroundImage: 'url(' + backgroundGif + ')' }"
  >
    <div class="auth-box">
      <h2>{{ isLogin ? page_title[language].login : page_title[language].register }}</h2>

      <form @submit.prevent="isLogin ? login() : register()">
        <input v-model="username" type="text" :placeholder="placeholders[language].username" required />
        <input
          v-model="password"
          type="password"
          :placeholder="placeholders[language].password"
          required
        />
        <input
          v-if="!isLogin"
          v-model="email"
          type="email"
          :placeholder="placeholders[language].email"
          required
        />

        <button type="submit" @click="playClickSound">{{ isLogin ? buttons[language].login : buttons[language].register }}</button>
      </form>

      <p @click="toggleMode">
        {{ isLogin ? toggle_text[language].register : toggle_text[language].login }}
      </p>

      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { sounds } from '@/utils/sounds';
export default {
  data() {
    return {
      backgroundGif: require('@/assets/world/maximum.gif'),
      username: "",
      password: "",
      isLogin: true,
      errorMessage: "",
      language: localStorage.getItem("language") || "en",
      email: "",


      page_title: {
        en: { login: "Vitalia - Login", register: "Vitalia - Register" },
        el: { login: "Vitalia - Σύνδεση", register: "Vitalia - Εγγραφή" },
        it: { login: "Vitalia - Accesso", register: "Vitalia - Registrati" },
        ro: { login: "Vitalia - Autentificare", register: "Vitalia - Înregistrare" },
        uk: { login: "Vitalia - Вхід", register: "Vitalia - Реєстрація" },
      },

      placeholders: {
        en: { username: "Username", password: "Password", email: "Parent Email" },
        el: { username: "Όνομα χρήστη", password: "Κωδικός", email: "Email γονέα" },
        it: { username: "Nome utente", password: "Password", email: "Email genitore" },
        ro: { username: "Nume utilizator", password: "Parolă", email: "Email părinte" },
        uk: { username: "Ім'я користувача", password: "Пароль", email: "Електронна пошта батьків" },
      },

      buttons: {
        en: { login: "Login", register: "Register" },
        el: { login: "Σύνδεση", register: "Εγγραφή" },
        it: { login: "Accesso", register: "Registrati" },
        ro: { login: "Autentificare", register: "Înregistrare" },
        uk: { login: "Вхід", register: "Реєстрація" },
      },

      toggle_text: {
        en: { login: "Already have an account? Login", register: "Need an account? Register" },
        el: { login: "Έχετε ήδη λογαριασμό; Σύνδεση", register: "Χρειάζεστε λογαριασμό; Εγγραφή" },
        it: { login: "Hai già un account? Accedi", register: "Hai bisogno di un account? Registrati" },
        ro: { login: "Ai deja un cont? Autentificare", register: "Ai nevoie de un cont? Înregistrare" },
        uk: { login: "Вже маєте обліковий запис? Вхід", register: "Потрібен обліковий запис? Реєстрація" },
      },
    };
  },

  methods: {
    playClickSound() {
      sounds.buttonClick.play();
    },
    async login() {
      try {
        const response = await fetch(
          "https://erebus2.athenarc.gr/duse/login",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              username: this.username,
              password: this.password,
            }),
          }
        );

        const data = await response.json();
        if (response.ok) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("username", data.username);
          localStorage.setItem("language", data.language);

          this.$router.push({ name: "MainScene" });
        } else {
          this.errorMessage = data.error || "Login failed!";
        }
      } catch (error) {
        this.errorMessage = "Network error!";
      }
    },

    async register() {
      try {
        const response = await fetch(
          "https://erebus2.athenarc.gr/duse/register",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              username: this.username,
              password: this.password,
              email: this.email,
            }),
          }
        );

        const data = await response.json();
        if (response.ok) {
          this.isLogin = true;
        } else {
          this.errorMessage = data.error || "Registration failed!";
        }
      } catch (error) {
        this.errorMessage = "Network error!";
      }
    },

    toggleMode() {
      this.isLogin = !this.isLogin;
      this.errorMessage = "";
    },
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #2c3e50;
  color: white;
}

.auth-box {
  background: rgba(255, 255, 255, 0.9);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

h2 {
  margin-bottom: 20px;
  color: #2c3e50;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

input {
  width: 90%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  text-align: center; /* Ensures text inside input is centered */
}

button {
  width: 100%;
  padding: 12px;
  background-color: #3498db;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-size: 16px;
  transition: background 0.3s ease;
}

button:hover {
  background-color: #2980b9;
}

p {
  cursor: pointer;
  margin-top: 10px;
  color: #f39c12;
  background-color: #333333;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>
